import {
  Box,
  Button,
  DialogContent,
  Divider,
  Stack,
  Typography,
} from "@mui/material";
import { Col, Form, Row } from "react-bootstrap";
import {
  Control,
  Controller,
  FieldArrayWithId,
  FieldErrors,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from "react-hook-form";
import { Add, Remove } from "@mui/icons-material";

import CollectionFragranceInput from "./CollectionFragranceInput";
import { SelectInputType } from "mocks/quizInputs";
import {
  AnswerType,
  CognitiveCategoryType,
  CollectionType,
  QuestionType,
  QuizType,
} from "app/types";
import ContentQuestionFormView from "./ContentQuestionFormView";
import { QuestionFormType } from "../update-type";
import { QUIZ_TYPES_CONTANTS } from "app/types/quiz-constants";
import { ChangeEvent, useEffect, useState } from "react";
import { showMensage } from "app/services/FeaturesElement";
import { Box as BoxStyled } from "app/pages/admin/components";

type DialogContentViewProps = {
  errors: FieldErrors<QuestionType>;
  answers: Array<AnswerType>;
  styleInput: {
    backgroundColor: string;
    color: string;
  };
  control: Control<QuestionFormType, any>;
  setValue: UseFormSetValue<QuestionFormType>;
  watch: UseFormWatch<QuestionFormType>;
  selectedType: SelectInputType;
  collections: Array<CollectionType>;
  fields: FieldArrayWithId<QuestionType, "answers", "id">[];
  cognitiveCategories: Array<CognitiveCategoryType>;
  audiometryCategories: CognitiveCategoryType[];
  audioDeviceType: any[];
  audioChannel: any[];
  quiz: QuizType;
  preViewImage: string;
  cognitiveInputs: Array<{ type: string; name: string }>;
  translate: (key: string) => string;
  showModalAnswersImage: () => void;
  append: UseFieldArrayAppend<QuestionFormType, "answers">;
  remove: UseFieldArrayRemove;
  handleDescChange: (index: number, value: string) => void;
  register: UseFormRegister<QuestionFormType>;
  handleFileQuestion: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClearQuest: () => void;
  handleQuestChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const DialogContentView = ({
  translate,
  showModalAnswersImage,
  errors,
  answers,
  styleInput,
  control,
  setValue,
  watch,
  append,
  selectedType,
  collections,
  remove,
  handleDescChange,
  register,
  fields,
  cognitiveCategories,
  audiometryCategories,
  audioDeviceType,
  audioChannel,
  quiz,
  handleFileQuestion,
  preViewImage,
  cognitiveInputs,
  handleClearQuest,
  handleQuestChange,
}: DialogContentViewProps) => {
  const [audiometryRightAnswers, setAudiometryRightAnswers] = useState<
    { key: number; answer: AnswerType }[]
  >([]);

  useEffect(() => {
    if (
      answers.length === 0 ||
      (answers.length === 1 && answers[0].desc === "")
    ) {
      setAudiometryRightAnswers([]);
    } else {
      if (!watch("rightAnswer")) {
        return;
      }

      const rightAnswers = watch("rightAnswer").split(";");
      if (rightAnswers.length > 0 && rightAnswers[0]) {
        const newAnswers = rightAnswers
          .map(rightAnswer => {
            const index = answers.findIndex(
              answer => answer.desc === rightAnswer,
            );
            const answer = answers[index];

            if (answer) {
              return { key: index, answer };
            }

            return undefined;
          })
          .filter(answer => answer !== undefined);

        setAudiometryRightAnswers(newAnswers);
      }
    }
  }, [answers]);

  const checkanswers =
    !!answers.length &&
    answers.every(answer => answer.quizQuestionAnswerId > 0) &&
    (selectedType === "image" || +quiz.type === QUIZ_TYPES_CONTANTS.AUDIOMETRY);

  const helperText = (text?: string) => (
    <Form.Text className="text-danger">{text}</Form.Text>
  );

  const selectAnswerAudiometry = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const isChecked = e.target.checked;

    if (isChecked && audiometryRightAnswers.length > 2) {
      showMensage(
        translate,
        null,
        `${translate("screens_quiz_labels_audiometry_error_right_answer")}`,
      );
      return;
    }

    const newAnswer = answers.find((_, indexAnswer) => indexAnswer === index);

    let newAudiometryRightAnswers: { key: number; answer: AnswerType }[] = [];

    if (newAnswer) {
      if (isChecked) {
        const containsData = audiometryRightAnswers.some(
          rightAnswer => rightAnswer.key === index,
        );

        if (containsData) {
          newAudiometryRightAnswers = audiometryRightAnswers.map(rightAnswer =>
            rightAnswer.key === index
              ? { ...rightAnswer, answer: newAnswer }
              : rightAnswer,
          );
        } else {
          newAudiometryRightAnswers = [
            ...audiometryRightAnswers,
            { key: index, answer: newAnswer },
          ];
        }
      } else {
        newAudiometryRightAnswers = audiometryRightAnswers.filter(
          rightAnswer => rightAnswer.key !== index,
        );
      }

      // newAudiometryRightAnswers = newAudiometryRightAnswers.sort(
      //   (a, b) => a.key - b.key,
      // );

      setAudiometryRightAnswers(newAudiometryRightAnswers);

      let rightAnswerValue = "";

      newAudiometryRightAnswers.forEach((rightAnswer, index) => {
        rightAnswerValue += `${index !== 0 ? ";" : ""}${
          rightAnswer.answer.desc
        }`;
      });

      // console.log("RESPOSTA CERTA: ", rightAnswerValue)

      setValue("rightAnswer", rightAnswerValue);
    }
  };

  return (
    <DialogContent>
      <ContentQuestionFormView
        cognitiveCategories={cognitiveCategories}
        audiometryCategories={audiometryCategories}
        audioDeviceType={audioDeviceType}
        audioChannel={audioChannel}
        cognitiveInputs={cognitiveInputs}
        collections={collections}
        control={control}
        errors={errors}
        preViewImage={preViewImage}
        quiz={quiz}
        selectedType={selectedType}
        styleInput={styleInput}
        watch={watch}
        handleClearQuest={handleClearQuest}
        handleFileQuestion={handleFileQuestion}
        handleQuestChange={handleQuestChange}
        register={register}
        helperText={helperText}
        translate={translate}
        setValue={setValue}
      />
      <Divider style={{ backgroundColor: "#757575", marginTop: 20 }} />
      <Typography variant="h6" mt={2} mb={2}>
        {translate("labels_answers")}
      </Typography>
      {fields.map((item, index) => (
        <Box key={item.id} mb={2}>
          {/* <Row className="d-flex align-items-center"> */}
          <Row
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Form.Group as={Col} lg={8} xs={12} className="mb-0 pt-1">
              <Form.Label>
                {translate("screens.quiz.labels.answer")}*
              </Form.Label>
              <BoxStyled
                style={{
                  display: "flex",
                  gap: "10px",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "0",
                }}
              >
                {+quiz.type === QUIZ_TYPES_CONTANTS.AUDIOMETRY && (
                  <Form.Check
                    style={{ transform: "scale(1.5)" }}
                    onChange={e =>
                      selectAnswerAudiometry(
                        e as ChangeEvent<HTMLInputElement>,
                        index,
                      )
                    }
                    checked={
                      answers.length === 0 ||
                      (answers.length === 1 && answers[0].desc === "") ||
                      !audiometryRightAnswers.find(
                        rightAnswer => rightAnswer.key === index,
                      )
                        ? false
                        : true
                    }
                  />
                )}
                <Form.Control
                  disabled={false}
                  placeholder={translate("screens.quiz.labels.answer")}
                  {...register(`answers.${index}.desc` as const)}
                  onChange={e => handleDescChange(index, e.target.value)}
                  style={styleInput}
                />
              </BoxStyled>

              {errors.answers &&
                helperText(errors.answers[index]?.desc?.message)}
            </Form.Group>
            <Form.Group as={Col} lg={3} xs={12} className="mb-0 pt-4">
              <Button
                variant="outlined"
                color="error"
                startIcon={<Remove />}
                onClick={() => remove(index)}
                sx={{ marginTop: 1 }}
              >
                {translate("screens_quiz_labels_deleteAnswer")}
              </Button>
            </Form.Group>
            <CollectionFragranceInput
              collections={collections}
              control={control}
              defaultSelectedOption={translate(
                "screens.quiz.placeholders.fragrances",
              )}
              index={index}
              label={translate("screens.fragrance.answerReferenceFragrance")}
              selectedType={selectedType}
              styleInput={styleInput}
            />
          </Row>
        </Box>
      ))}
      {errors.rightAnswer && helperText(errors?.rightAnswer.message)}
      <Stack spacing={2}>
        <Divider style={{ backgroundColor: "#757575" }} />
        <Button
          variant="outlined"
          color="info"
          startIcon={<Add />}
          onClick={() =>
            append({
              quizQuestionAnswerId: 0,
              answerId: 0,
              desc: "",
              description: "",
              nextQuizQuestionId: 0,
            })
          }
        >
          {translate("screens_quiz_labels_addAnswer")}
        </Button>
      </Stack>
      {+quiz.type !== QUIZ_TYPES_CONTANTS.AUDIOMETRY && (
        <Form.Group as={Col} lg={"12"} xs="12" className="mb-0 pt-2">
          <Form.Label>
            {translate("screenApp.results.rightResponse")}
          </Form.Label>
          <Controller
            name="rightAnswer"
            control={control}
            render={({ field }) => (
              <Form.Select {...field} style={styleInput}>
                <option value="">
                  {translate("screenApp.quiz.selectOption")}
                </option>
                {answers.map((item, index) => (
                  <option key={index} value={item.desc}>
                    {item.desc}
                  </option>
                ))}
              </Form.Select>
            )}
          />
        </Form.Group>
      )}
      {checkanswers && (
        <Stack spacing={2}>
          <Divider style={{ backgroundColor: "#757575" }} />
          <Button
            variant="outlined"
            color="inherit"
            onClick={showModalAnswersImage}
          >
            {translate("screens_quiz_answer_image_edit")}
          </Button>
        </Stack>
      )}
    </DialogContent>
  );
};

export default DialogContentView;
